import { createModuleWithSlice } from "@comact/crc";
import * as requests from "./requests";
import * as selectors from "./selectors";
import slice from "./slices";

export * from "./model";

export const FeatureFlagsModule = createModuleWithSlice({
    slice, actions: slice.actions, requests, selectors,
});
